export default __webpack_public_path__ + "static/media/GraphicIcon.d4b0b2cf.svg";